import localStorageHelper from "../helpers/local-storage-helper"
import messagesNotifyHelper from "../helpers/messages-notify-helper"
import { EventBus } from '../event-bus';
import AppConstants from "../appConstants";
import layoutService from "../providers/layoutService";
import mediaService from "../providers/mediaService";
import router from '../router';
import updateDomHelper from '../helpers/update-dom-helper';

const mutations = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width
  },

  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList.data.findIndex((item) => item.index == payload.index)

    // update the main list
    state.navbarSearchAndPinList.data[index].highlightAction = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList.data[index])
    }
    else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.index == payload.index)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp = false
    let lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited = state.starredPages.slice(0, 10)
    state.starredPages = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  UPDATE_DISPLAY_SYSTEM(state, val) { state.displaySystem = val },
  TOGGLE_CONTENT_OVERLAY(state, val) { state.bodyOverlay = val },
  UPDATE_PRIMARY_COLOR(state, val) { state.themePrimaryColor = val },
  UPDATE_THEME(state, val) {
    state.theme = val;
    if (state.isAuthenticated) {
      layoutService.saveLayout({ theme: val }, new URLSearchParams());
    }
  },
  UPDATE_CAN_DISPLAY_TICKER(state, val) {
    state.canDisplayTicker = val;
    if (state.isAuthenticated) {
      layoutService.saveLayout({ canDisplayTicker: val }, new URLSearchParams());
    }
  },
  SET_CAN_DISPLAY_TICKER(state, val) {
    state.canDisplayTicker = val;
  },
  UPDATE_TICKER_VIEW_AT_THE_TOP(state, val) {
    state.tickerViewAtTheTop = val;
    if (state.isAuthenticated) {
      layoutService.saveLayout({ tickerViewAtTheTop: val }, new URLSearchParams());
    }
  },
  SET_TICKER_VIEW_AT_THE_TOP(state, val) {
    state.tickerViewAtTheTop = val;
  },
  UPDATE_VIEW_IMPORTANT_TICKERS(state, val) {
    state.viewImportantTickers = val;
  },
  UPDATE_VIEW_HIGHLIGHTS_TICKERS(state, val) {
    state.viewHighlightsTickers = val;
  },
  UPDATE_BIOMETRY(state, val) { state.biometry = val },
  UPDATE_WINDOW_WIDTH(state, width) { state.windowWidth = width },
  UPDATE_WINDOW_SCROLL_Y(state, val) { state.scrollY = val },


  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  UPDATE_USER_INFO(state, user) {
    // Get Data localStorage
    if (user) {
      state.AppActiveUser = user;
    } else {
      const localUser = localStorageHelper.getCurrentUser();
      if (localUser.nome) {
        state.AppActiveUser = localStorageHelper.getCurrentUser();
      }
    }

  },

  UPDATE_IS_PRODUCTION(state, isProduction) {
    state.isProduction = isProduction;
  },

  UPDATE_DEVICE_IS_DESKTOP(state, isDesktop) {
    state.isDesktop = isDesktop;
  },

  UPDATE_REPORT_VIEW_STYLE(state, val) {
    state.reportViewStyle = val;
  },
  INSERT_PLAYLIST(state, val) {
    if (state.playlist.findIndex(c => c._id === val._id) < 0) {
      if (state.playlist.length == 0 && !state.playlistItemSelected) {
        state.playlistItemSelected = val;
      }
      state.playlist.push(val);
    }
    messagesNotifyHelper.addPlaylistNotify(val);
    EventBus.$emit(AppConstants.BUS_EVENT_OPEN_PLAYLIST, false);
  },
  REMOVE_PLAYLIST(state, val) {
    state.playlist.splice(state.playlist.findIndex(c => c._id === val._id), 1);

    if (state.playlistItemSelected) {
      if (state.playlistItemSelected._id == val._id) {
        state.playlistItemSelected = null;
      }
    }
  },
  CLEAR_PLAYLIST(state, val) {
    state.playlist = [];
    state.currentMedia = null;
  },
  PLAYLIST_ADD_ITEM_SELECTED(state, val) {
    state.playlistItemSelected = val;
  },
  PLAYLIST_REMOVE_ITEM_SELECTED(state, val) {
    state.playlistItemSelected = null;
  },
  UPDATE_SUBSCRIBETOOLS_VISIBILITY(state, val) {
    state.displaySubscribeTools = val;
  },
  UPDATE_NAVMENU_VISIBILITY(state, val) {
    state.displayNavMenu = val;
  },
  INIT_FAVORITE_CONTENT_DATA(state, val) {
    state.favoriteContent = val;
  },
  UPDATE_FAVORITE_CONTENT(state, val) {
    const commodity = state.favoriteContent.find(c => c.commodity == val.commodity);
    if (commodity) {
      if (commodity.content.findIndex(item => item.id == val.content.id) >= 0) {
        commodity.content.splice(commodity.content.findIndex(c => c.id == val.content.id), 1);
      } else {
        commodity.content.push(val.content);
      }
      state.favoriteContent[state.favoriteContent.findIndex(c => c.commodity == val.commodity)] = commodity;
    } else {
      state.favoriteContent.push({ commodity: val.commodity, content: [val.content] });
    }
    localStorageHelper.updateFavoriteMenuContent(state.favoriteContent);
    layoutService.saveLayout({ favoriteContent: state.favoriteContent }, new URLSearchParams());
  },
  UPDATE_CURRENT_FILTER(state, val) {
    state.currentFilter = val;
    // localStorageHelper.updatecurrentFilter(state.currentFilter);
  },

  // /////////////////////////////////////////////
  // INFORMATIVE
  // /////////////////////////////////////////////
  UPDATE_CURRENT_COMMODITY(state, val) {
    // console.log('updateCurrentCommodity', val);
    state.currentCommodity = val;
    // router.replace({name: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${val.id}`});
  },
  UPDATE_CURRENT_CONTENT(state, val) {
    state.currentContent = val;
  },
  UPDATE_CURRENT_CONTENT_TO_DEFAULT(state) {
    state.currentContent = AppConstants.INFORMATIVE_FILTER_ALL_OPTION;
  },
  UPDATE_CURRENT_REPORT_TYPE(state, val) {
    state.currentReportType = val;
  },

  UPDATE_USER_AUTHENTICATED(state, val) {
    state.isAuthenticated = val;
  },

  UPDATE_RATE_TEXT_SPREECH(state, val) {
    state.AppActiveUser.rateTextSpeech = val;
  },

  UPDATE_ISPAUSED_TEXT_SPREECH(state, val) {
    state.textSpeechIsPaused = val;
  },
  UPDATE_ISPLAYING_TEXT_SPREECH(state, val) {
    state.textSpeechIsPlaying = val;
  },
  UPDATE_SUBJECT_MENU(state, val) {
    state.subjectsMenu = val;
  },
  UPDATE_CURRENT_MEDIA(state, val) {
    state.currentMedia = val;
    // state.currentMediaData.youtubePlayer.currentTime = 0;
    // state.currentMediaData.youtubePlayer.isPlaying = false;
    // state.currentMediaData.audioPlayer.currentTime = 0;
    // state.currentMediaData.audioPlayer.isPlaying = false;
  },
  UPDATE_YOUTUBE_CURRENT_TIME(state, val) {
    state.currentMediaData.youtubePlayer.currentTime = val;
  },
  UPDATE_YOUTUBE_ISPLAYING(state, val) {
    state.currentMediaData.youtubePlayer.isPlaying = val;
  },
  UPDATE_AUDIO_CURRENT_TIME(state, val) {
    state.currentMediaData.audioPlayer.currentTime = val;
  },
  UPDATE_AUDIO_ISPLAYING(state, val) {
    state.currentMediaData.audioPlayer.isPlaying = val;
  },
  UPDATE_PLAYLIST_OPEN(state, val) {
    state.playlistOpen = val;
  },
  UPDATE_ZOOM(state, val) {
    state.AppActiveUser.zoom = val;
    // updateDomHelper.updateZoom(val);
    if (state.isAuthenticated) {
      layoutService.saveLayout({ zoom: val }, new URLSearchParams());
    }
  },
  UPDATE_ZOOM_DETAIL(state, val) {
    state.AppActiveUser.zoomDetail = val;
    if (state.isAuthenticated) {
      layoutService.saveLayout({ zoomDetail: val }, new URLSearchParams());
    }
  },
  UPDATE_FORMAT_ALIGN_DETAIL(state, val) {
    state.AppActiveUser.formatAlignDetail = val;
    if (state.isAuthenticated) {
      layoutService.saveLayout({ formatAlignDetail: val }, new URLSearchParams());
    }
  },
  UPDATE_LATEST_MEDIA(state, val) {
    state.latestMedia = val;
  },
  UPDATE_CONTENT_PRIVATE(state, val) {
    state.contentPrivate = val;
  },
  UPDATE_QUOTES_PUBLIC(state, val) {
    state.quotesPublic = val;
  },

  UPDATE_FILTER_USERS(state, val) {
    state.filterUsers = val;
  },

  UPDATE_REFRESH_ACTIVE(state, val) {
    state.refreshActive = val;
  },
  UPDATE_CONTENT_SUBMENU_REDUCE_SIDEBAR(state, val) {
    state.contentSubmenuReduceSidebar = val;
  },
  UPDATE_MOBILE_IOS(state, val) {
    state.isMobileIOS = val;
  },
  SET_NOTIFICATION(state, val) {
    state.notifications = val;
  },
  UPDATE_NOTIFICATION(state, val) {
    state.notifications.push(val);
  },

  SET_SCHEDULE_DATA(state, val) {
    state.scheduleData = val;
  },
  INSERT_SCHEDULE_DATA(state, val) {
    const index = state.scheduleData.findIndex(item => item['_id'] == val['_id']);
    if (index < 0) {
      state.scheduleData.push(val);
      if (state.isAuthenticated) {
        layoutService.saveLayout({
          saved_news: state.scheduleData.map(item => {
            return { _id: item['_id'] }
          })
        }, new URLSearchParams());
      }
    }
  },
  REMOVE_SCHEDULE_DATA(state, val) {
    state.scheduleData.splice(state.scheduleData.findIndex(c => c._id === val._id), 1);
    if (state.isAuthenticated) {
      layoutService.saveLayout({
        saved_news: state.scheduleData.map(item => {
          return { _id: item['_id'] }
        })
      }, new URLSearchParams());
    }
  },
  CLEAR_SCHEDULE_DATA(state, val) {
    state.scheduleData = [];
    if (state.isAuthenticated) {
      layoutService.saveLayout({ saved_news: [] }, new URLSearchParams());
    }
  },

  UPDATE_QUOTES_CONTENT_LIST_DATA(state, val) {
    state.quotesContentList = val;
  },
  UPDATE_BIOMETRY_SECRETS(state, val) {
    state.biometrySecrets = val;
  },
  UPDATE_HAS_BIOMETRY(state, val) {
    state.hasBiometry = val;
  },
  UPDATE_IS_BIOMETRY_AVAILABLE(state, val) {
    state.isBiometryAvailable = val;
  },
  UPDATE_BIOMETRY_SECRETS_STATUS(state, val) {
    state.biometrySecretsStatus = val;
  },
  UPDATE_BIOMETRY_TYPE(state, val) {
    state.biometryType = val;
  },
  UPDATE_ON_LOGIN(state, val) {
    state.onLogin = val;
  },
  UPDATE_CORRELATION_ID(state, val) {
    state.correlationId = val;
  },
  UPDATE_HIGHLIGHT_COLLAPSED(state, val) {
    state.highlightCollapsed = val;
  },
  UPDATE_INSET_TOP(state, val) {
    state.insetTop = val;
  },
  UPDATE_INSET_BOTTOM(state, val) {
    state.insetBottom = val;
  },
  UPDATE_INSET_LEFT(state, val) {
    state.insetLeft = val;
  },
  UPDATE_INSET_RIGHT(state, val) {
    state.insetRight = val;
  },
};

export default mutations

